export default __webpack_public_path__ + "static/media/loader-logo.68901552.svg";